/**
 * AUDIT LOG THUNKS — Solo lettura: un unico thunk fetchAuditLog. Non usa
 * createCrudThunks (richiederebbe getById/create/update/remove inesistenti)
 * né requireGroupId (l'endpoint /user/auditLog è user-scoped, risolto dal
 * Bearer). Pattern async/await + try/catch + rejectWithValue(extractError).
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Page } from '@crm/shared';
import { extractError } from '../../store/thunkHelpers';
import { auditLogApi, type AuditLogListParams } from './auditLogApi';
import type { AccessEntry } from './auditLogTypes';

export const fetchAuditLog = createAsyncThunk<
  Page<AccessEntry>,
  AuditLogListParams | undefined,
  { rejectValue: string }
>('auditLog/fetchAll', async (params, { rejectWithValue }) => {
  try {
    return await auditLogApi.getAll(params);
  } catch (err: unknown) {
    return rejectWithValue(extractError(err));
  }
});
